export function preCallInstructionsRender() { return `<div class="pre-call-instructions-view">
    <h3>${ this.headingText }</h3>
    <div class="disclaimer-container">
        <div class="disclaimer">
            <div class="disclaimer-icon">
            </div>
            <div class="text">
                <p class="pre-call-disclaimer-text">${ this.disclaimerText }</p>
            </div>
        </div>
    </div>
    <div class="pre-call-info">
        <div class="text">
            <p>${ this.primaryText } </p>
            <p>${ this.secondaryText }</p>
            <p>Look for a pop-up like this near the top of your browser after you proceed to the next page:</p>
        </div>
    </div>

    <div class="pre-call-display-image">
        <div class="card">
            <p class="text">${this.voiceOnlyCall ? this.browserSettingPopupVoiceText : this.browserSettingPopupText}</p>
            <div class="card-container">
               <button class="card-button">Don't Allow</button>
               <button class="card-button allow-button">Allow</button>
            </div>
         </div>
    </div>

    <div class="pre-call-instructions-footer">
        <button class="pre-call-instructions-footer-button" ld--elist="click" ld-on-click="onClickGetStarted">
            <i class="fa fa-settings"></i> ${ this.startButtonText }
        </button>
    </div>
</div>
`  }